module.exports = __webpack_public_path__ + "img/notebook.307e41fe.svg";